import PropTypes from 'prop-types';
import React from 'react';
import { getComponentClasses } from '@99designs/utils/app';
import deprecated from '../lib/deprecated';

export default class Avatar extends React.Component {
    placeholder() {
        return (
            <span className={this.getComponentClasses()}>
                <span className="avatar__image avatar__image--placeholder" />
            </span>
        );
    }

    avatarImage() {
        return <img className="avatar__image" src={this.props.user.avatarUrl} />;
    }

    avatar() {
        const attrs = this.props.isOnline ? { 'data-online': true } : {};

        if (this.props.isLinked && this.props.user.profileUrl) {
            return (
                <a
                    className={this.getComponentClasses()}
                    href={this.props.user.profileUrl}
                    {...attrs}
                >
                    {this.avatarImage()}
                    {this.onlineIndicator()}
                </a>
            );
        } else {
            return (
                <span className={this.getComponentClasses()} {...attrs}>
                    {this.avatarImage()}
                    {this.onlineIndicator()}
                </span>
            );
        }
    }

    onlineIndicator() {
        return <div className="avatar__indicator" />;
    }

    render() {
        if (this.props.user) {
            return this.avatar();
        } else {
            return this.placeholder();
        }
    }

    getComponentClasses() {
        let variations = this.props.variations;
        if (this.props.size) {
            if (variations === DEFAULT_VARIATIONS) {
                variations = [];
            }
            deprecated(`size is deprecated, prefer variations={[\'${this.props.size}\']}`);
            variations = variations.concat(this.props.size);
        }
        return getComponentClasses('avatar', variations);
    }
}

Avatar.propTypes = {
    user: PropTypes.shape({
        profileUrl: PropTypes.string,
        avatarUrl: PropTypes.string,
    }),
    variations: PropTypes.array,
    size: PropTypes.oneOf(['extra-small', 'small', 'medium', 'large', 'extra-large']),
    isLinked: PropTypes.bool,
    isOnline: PropTypes.bool,
};

const DEFAULT_VARIATIONS = ['medium'];
Avatar.defaultProps = {
    variations: DEFAULT_VARIATIONS,
    isLinked: true,
    isOnline: false,
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/Avatar.jsx